export default __webpack_public_path__ + "static/media/FlowesFoodsGift.3d6912cf.svg";